import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getVisibleSelectedParameters, getFrequencyDataSetLength } from 'store';

import ToolsetPlaceholderComponent from './Component';

const unavailablePagesForFrequencyMode = {
  '/toolset/descriptive-statistics': 'Descriptive Statistics',
  '/toolset/sampling-distributions': 'Sampling',
  '/toolset/regression': 'Regression'
};

const ToolsetPlaceholderContainer = WrappedComponent => {
  const HigherOrderComponent = props => {
    const { parametersSelected, isDatasetTypeFrequency, ...restProps } = props;

    const location = useLocation();

    const unavailablePageName = unavailablePagesForFrequencyMode[location.pathname];
    if (unavailablePageName && isDatasetTypeFrequency) {
      return (
        <ToolsetPlaceholderComponent message={`${unavailablePageName} page is not available for frequency or contingency tables.`} />
      );
    }
    const messageForDatasetPage = 'Please select Dataset or Upload your CSV file on the Import Dataset tab!';
    const messageForOtherPages = 'Please select Dataset and Parameters!';

    if (!parametersSelected) {
      return (
        <ToolsetPlaceholderComponent message={location.pathname === '/toolset/dataset' ? messageForDatasetPage : messageForOtherPages} />
      );
    }

    return <WrappedComponent {...restProps} />;
  };

  HigherOrderComponent.propTypes = {
    parametersSelected: PropTypes.bool.isRequired,
    isDatasetTypeFrequency: PropTypes.number
  };

  const mapStateToProps = state => ({
    parametersSelected: !!Object.keys(getVisibleSelectedParameters(state))
      .length,
    isDatasetTypeFrequency: getFrequencyDataSetLength(state)
  });

  return connect(mapStateToProps)(HigherOrderComponent);
};

export default ToolsetPlaceholderContainer;
